var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFruit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#002069"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12942_10337)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.6992 30.181C45.9364 29.3278 47.3721 24.3589 49.2323 22.0878C49.3197 21.9874 49.4695 21.9749 49.5694 22.0627C52.1037 24.3966 53.5394 29.0643 53.7517 29.7921C53.7641 29.8548 53.7517 29.9175 53.7267 29.9803L50.6056 35.0746C50.5307 35.2001 50.3434 35.2252 50.2435 35.1123L45.7616 30.4069C45.7616 30.4069 45.6867 30.2689 45.7117 30.181H45.6992Z",
    fill: "#7BA0C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2074 24.8734C38.8328 24.773 38.5582 25.2247 38.8328 25.5008C40.8553 27.546 45.1374 32.6278 45.075 38.8013C45.0001 46.2671 53.3647 41.4112 54.3634 39.8804C54.4383 39.7549 54.4508 39.6043 54.3634 39.4788C53.6268 38.2994 47.7966 27.2575 39.2074 24.8734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3308 24.8734C60.7053 24.773 60.98 25.2247 60.7053 25.5008C58.6828 27.546 54.4007 32.6278 54.4631 38.8013C54.538 46.2671 46.1735 41.4112 45.1747 39.8804C45.0998 39.7549 45.0873 39.6043 45.1747 39.4788C45.9113 38.2994 51.7415 27.2575 60.3308 24.8734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4869 28.6126C35.1124 28.5122 34.8377 28.9639 35.1124 29.24C37.1348 31.2852 41.417 36.367 41.3546 42.5404C41.2797 50.0063 47.9338 40.0937 48.9451 38.5628C49.02 38.4374 49.0325 38.2868 48.9451 38.1613C48.2085 36.9818 44.0886 30.9966 35.4869 28.6126Z",
    fill: "#7BA0C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0511 28.6126C64.4256 28.5122 64.7003 28.9639 64.4256 29.24C62.4032 31.2852 58.121 36.367 58.1834 42.5404C58.2584 50.0063 51.6042 40.0937 50.5929 38.5628C50.518 38.4374 50.5055 38.2868 50.5929 38.1613C51.3295 36.9818 55.4494 30.9966 64.0511 28.6126Z",
    fill: "#7BA0C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4283 38.3621H48.4707C41.5206 38.3621 35.8865 44.0248 35.8865 51.0101V65.352C35.8865 72.3373 41.5206 78 48.4707 78H52.4283C59.3784 78 65.0126 72.3373 65.0126 65.352V51.0101C65.0126 44.0248 59.3784 38.3621 52.4283 38.3621Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12942_10337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 56,
    fill: "white",
    transform: "translate(35 22)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFruit);
export default __webpack_public_path__ + "static/media/fruit.146d89dd3fb7dc16de09a43aadc1cb5d.svg";
export { ForwardRef as ReactComponent };